import * as React from 'react';

import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import {styled} from '@mui/material/styles';
import DocumentsTableViewComponent from './../../components/Documents/DocumentsTableView';

export default function DocumentsPage(): React.ReactElement {

    const Item = styled(Paper)(({theme}) => ({
        ...theme.typography.body2,
        padding: theme.spacing(3),
        backgroundColor: "#fffcf8",
        //marginLeft: 20,
        marginRight: 20,
        marginBottom: 20,
        textAlign: 'center',
        border: 'none',
        borderRadius: 0,
        boxShadow: '0',
        color: theme.palette.text.secondary,
        ...theme.applyStyles('dark', {
            backgroundColor: 'grey',
        }),
    }));

    return (
        <Grid container>
            <Grid size={12}>
                <Item>
                    <DocumentsTableViewComponent/>
                </Item>
            </Grid>
        </Grid>
    )
}
